module.exports = __webpack_public_path__ + "img/6355606052646267978494818.ff0233b7.jpg";